import { apis } from 'ui-common'

export default {
  getAllergens: () => apis.$get('/allergens')
}
